<template>
  <v-container
    class="pa-4"
    v-if="missionDetail"
    :style="{ '--theme-color-custom': site.color }"
  >
    <div v-if="missionDetail?.use_timer" class="timer-container">
      <div class="timer-sub-container">
        <div
          style="position: absolute; width: 100%; height: 100%; padding: 4px"
        >
          <svg
            width="250"
            height="250"
            viewBox="0 0 250 250"
            class="circular-progress"
            :style="{ '--progress': timeValue }"
          >
            <circle class="bg"></circle>
            <circle class="fg"></circle>
          </svg>
        </div>
        <div style="position: absolute; font-size: 16px; font-weight: 500">
          {{ timeSec | formatTimer }}
        </div>
      </div>
    </div>

    <v-row no-gutters>
      <v-col cols="12">
        <v-btn
          fab
          x-small
          :color="site.color"
          @click="redirectTo()"
          dark
          class="mb-4"
        >
          <v-icon large>mdi-chevron-left</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row no-gutters>
      <v-col class="d-flex justify-center">
        <div style="max-height: 240px">
          <img
            :src="
              missionDetail.image_url
                ? missionDetail.image_url
                : missionDetail.image_path
            "
            style="
              max-width: 100%;
              max-height: 240px;
              width: auto;
              height: auto;
              border-radius: 10px;
              object-fit: contain;
              display: block;
              margin: 0 auto;
            "
            @error="
              onImageError(
                $event,
                missionDetail,
                missionDetail.image_url ? 'image_url' : 'image_path'
              )
            "
          />
        </div>
      </v-col>
    </v-row>

    <v-row no-gutters class="mt-3">
      <v-col cols="12">
        <v-row no-gutters>
          <v-col cols="12">
            <p class="text-subtitle-1 text--primary mx-0 text-center mb-0">
              {{ missionDetail.name }}
            </p>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12" class="text-start pa-0 d-flex justify-start">
            <v-chip
              class="mb-4 mt-2"
              color="black"
              dark
              small
              v-if="missionDetail.anonymous == true"
            >
              <v-icon small>mdi-account-cowboy-hat-outline</v-icon>
              {{ $t("textIncognito") }}
            </v-chip>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row no-gutters justify="center" class="mb-5">
      <v-col cols="12">
        <Survey
          v-if="survey"
          :survey="survey"
          style="border-radius: 8px; background-color: transparent"
        />
      </v-col>
    </v-row>

    <v-dialog v-model="dialogConditionResult" persistent max-width="600px">
      <v-card style="padding: 16px 0px 12px 0px">
        <v-card-text>
          <v-img
            :src="conditionResultDetail ? conditionResultDetail.image_path : ''"
            contain
            class="white"
            max-height="360px"
          ></v-img>
          <p
            class="mb-0 text-title pt-2"
            style="-webkit-box-orient: vertical; white-space: pre-wrap"
          >
            {{ conditionResultDetail ? conditionResultDetail.description : "" }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            class="pa-5 rounded-lg white--text"
            :color="site.color"
            @click="confirmConditionResult()"
          >
            {{ $t("confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DialogRewardMission
      :dialogRewardMission="dialogRewardMission"
      :missionDetail="missionDetail"
      :userAddress="userAddress"
      :detail="detail"
      :isLoading="isLoading"
      @openDialogAddress="dislogAddressVisible = true"
      @confirmMissionReward="confirmMissionReward"
    />

    <DialogAddressRedeemFinal
      @selectedAddress="handleSelectedAddress"
      :dislogAddressVisible="dislogAddressVisible"
      @close="dislogAddressVisible = false"
      :site="site"
    />
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import Axios from "@/config/customer-service";
import { Survey } from "survey-vue-ui";
import { Model, Serializer } from "survey-core";
import "survey-core/defaultV2.min.css";
import { themeJson } from "../../../scss/themeJson.js";
import moment from "moment";
import DialogAddressRedeemFinal from "../../../components/reward/dialogAddressRedeemFinal.vue";
import * as htmlToImage from "html-to-image";
import {
  addClassQlEditorToSDDisplay,
  addDivCustomInputMaskPattern,
  formattedForSave,
  transformJsonCustomInputMask,
} from "../../../config/general-function.js";
import DialogRewardMission from "./component/dialogRewardMission.vue";
import { provinces } from "../../../config/location/provinces.js";
import { districts } from "../../../config/location/districts.js";
import { sub_districts } from "../../../config/location/sub_districts.js";

Serializer.addProperty("itemvalue", {
  name: "score:number",
});
Serializer.addProperty("file", {
  name: "maxUpload",
});
export default {
  inject: ["isAppLoading"],
  components: {
    Survey,
    DialogAddressRedeemFinal,
    DialogRewardMission,
  },
  data() {
    return {
      isLoading: false,
      missionDetail: {
        id: null,
        name: null,
        mission_status: null,
        schema_survey: null,
        image_url: null,
        image_path: null,
        image_upload: null,
        description: null,
        use_timer: false,
        time_sec: 0,
      },
      survey: null,
      status: "success",
      answer: null,
      dialogConditionResult: false,
      conditionResultDetail: null,
      timeSec: 0,
      timerInterval: null,
      timeValue: 100,
      timerValueInterval: null,

      dialogRewardMission: false,
      dataListAddress: [],
      addressSelect: {},
      addressTitle: "",
      canEdit: true,
      detail: {
        chooseAddress: "self",
        note: "",
        employee_note: "",
        is_use_id_card: false,
        id_card_image: null,
        id_card_image_watermark: null,
        watermark_text: null,
        file: null,
        image_error: null,
      },
      dislogAddressVisible: false,
      userAddress: null,
    };
  },

  async created() {
    this.addressTitle = this.$t("add");
    this.survey = new Model({});
    this.fetchAddress();
  },
  async mounted() {
    this.isAppLoading(true);
    await this.getMyMissionById(this.$route.params.id);
    this.onInit();
    // ========== ========== ========== ==========
    this.checkUpload();
    if (this.missionDetail.type == "exam") {
      this.survey.onComplete.add((sender, options) => {
        if (this.missionDetail.schema_survey.expected_type == "score") {
          const maxScore = this.calculateMaxScore(sender.getAllQuestions());
          const plainData = sender.getPlainData({
            calculations: [{ propertyName: "score" }],
          });
          const totalScore = this.calculateTotalScore(plainData);

          sender.setValue("maxScore", maxScore);
          sender.setValue("totalScore", totalScore);
          this.surveyComplete(sender, options);
        } else {
          const maxScore = this.calculateMaxQuestion(sender.getAllQuestions());
          const totalScore = this.calculateTotalScoreExam(sender.data);

          sender.setValue("maxScore", maxScore);
          sender.setValue("totalScore", totalScore);
          this.surveyComplete(sender, options);
        }
      });
      this.survey.clearInvisibleValues = "onHidden";
    }
    if (this.missionDetail.type == "survey") {
      this.survey.onComplete.add(this.surveyComplete);
    }
    if (this.missionDetail.type == "multi-upload") {
      this.survey.onComplete.add(this.surveyComplete);
    }
    if (this.missionDetail.type == "survey-summary") {
      this.survey.onComplete.add(this.surveyComplete);
    }
    this.uploadImage();
    this.onSetInterval();
    // ========== ========== ========== ==========
    this.isAppLoading(false);
  },

  methods: {
    redirectTo() {
      this.$router.push({
        name: "my-mission-detail",
        params: {
          id: this.$route.params.id,
        },
      });
    },
    onImageError(event, item, key) {
      if (item && item[key]) {
        item[key] = "";
      } else {
        event.target.style.display = "none";
      }
    },
    byhtmlToImage(element) {
      return new Promise((resolve) => {
        htmlToImage
          .toPng(element)
          .then((dataUrl) => {
            resolve(dataUrl);
          })
          .catch((error) => {
            console.error("Error byhtmlToImage:", error);
            resolve(null);
          });
      });
    },
    uploadImageDefault(file) {
      if (file) {
        let formData = new FormData();
        formData.append("image", file);
        formData.append("module", "IDCard");
        return new Promise((resolve, reject) => {
          Axios.post("uploadImageDefault", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                resolve(data.image_url);
              }
            })
            .catch((err) => {
              console.log(err);
              reject(null);
            });
        });
      } else {
        return null;
      }
    },
    async convertDetailImageBase64(data) {
      let listImageSrc = [data];
      const listImageSrcBase64 = listImageSrc
        .filter((x) => x.includes(";base64,"))
        .map((x) => {
          const detail = {
            old: x,
            new: null,
          };
          return detail;
        });
      if (listImageSrcBase64.length > 0) {
        for (let item of listImageSrcBase64) {
          const imageFile = await this.convertBase64ToFile(item.old, "image");
          if (imageFile) {
            const imageUrl = await this.uploadImageDefault(imageFile);
            if (imageUrl) {
              data = data.replace(item.old, imageUrl);
            }
          }
        }
      }
      return data;
    },
    convertBase64ToFile(base64, nameImage) {
      return new Promise((resolve) => {
        const fetchBase64 = fetch(base64);
        fetchBase64
          .then((r) => r.blob())
          .then((blobFile) => {
            const image = new File([blobFile], nameImage, {
              type: blobFile.type,
            });
            resolve(image);
          })
          .catch((err) => {
            console.log("convertBase64ToFile", err);
            resolve(null);
          });
      });
    },

    // ========== ========== Address ========== ==========
    fetchAddress() {
      Axios.get("address/list").then((res) => {
        if (res.data.status == "success") {
          this.dataListAddress = res.data.data.data;
          this.canEdit = res.data.data.can_edit;
          //select first address
          if (this.dataListAddress.length > 0) {
            this.selectAddress(this.dataListAddress[0]);
          }
        }
      });
    },
    selectAddress(item) {
      this.addressSelect = item;
    },
    handleSelectedAddress(chooseAddress) {
      this.userAddress = chooseAddress;
    },

    // ========== ========== ========== ==========
    onInit() {
      // first-time user playing
      if (typeof this.missionDetail.schema_survey === "string") {
        this.missionDetail.schema_survey = JSON.parse(
          this.missionDetail.schema_survey
        );
      }

      this.missionDetail.schema_survey.showCompletedPage = false;
      this.missionDetail.schema_survey.showPrevButton = true;
      // this.missionDetail.schema_survey.goNextPageAutomatic = true;
      this.missionDetail.schema_survey.goNextPageAutomatic = false;
      // this.missionDetail.schema_survey.showNavigationButtons = false;
      this.missionDetail.schema_survey.showNavigationButtons = true;
      this.missionDetail.schema_survey.completeText = {
        default: this.$t("submitResult"),
      };
      this.missionDetail.schema_survey.pageNextText = {
        default: this.$t("next"),
      };
      this.missionDetail.schema_survey.pagePrevText = {
        default: this.$t("back"),
      };

      this.missionDetail.schema_survey = this.setQuestionAddress(
        this.missionDetail.schema_survey
      );
      this.missionDetail.schema_survey = this.setQuestionBrandBranch(
        this.missionDetail.schema_survey
      );
      this.missionDetail.schema_survey = transformJsonCustomInputMask(
        this.missionDetail.schema_survey
      );
      this.survey = new Model(this.missionDetail.schema_survey);
      themeJson.cssVariables["--sjs-primary-backcolor"] = this.site.color;
      themeJson.cssVariables["--sjs-primary-backcolor-dark"] = this.site.color;
      this.survey.applyTheme(themeJson);
      // ========== ========== ========== ==========
      this.onValueChanged();
      this.onAfterRenderPage();
      this.onAfterRenderQuestion();
    },
    onAfterRenderPage() {
      this.survey.onAfterRenderPage.add(function (sender, options) {
        console.log(options);
        addClassQlEditorToSDDisplay();
      });
    },
    onAfterRenderQuestion() {
      this.survey.onAfterRenderQuestion.add((sender, options) => {
        const jsonObj = options.question.jsonObj;
        const prefix = jsonObj._customPrefix;
        const questionEl = options.htmlElement;
        if (prefix) {
          addDivCustomInputMaskPattern(questionEl, prefix);
        }
        addClassQlEditorToSDDisplay();
      });
    },
    onValueChanged() {
      const _isAppLoading = (param) => {
        this.isAppLoading(param);
      };
      this.survey.onValueChanged.add((sender, options) => {
        const name = options.name;
        const value = options.value;
        const questions = this.survey.getAllQuestions();
        // ========== ========== Set Null Value Invisible Question ========== ==========
        const invisible_questions = questions.filter((x) => !x.visible);
        for (let invisible_question of invisible_questions) {
          const _name = invisible_question.name;
          const model = this.survey.getQuestionByName(_name);
          if (model) {
            this.survey.setValue(_name, null);
          }
        }
        // ========== ========== Address ========== ==========
        if (name == "province") {
          const district = this.survey.getQuestionByName("district");
          if (district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = districts
                .filter((x) => x.province_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            district.readOnly = readOnly;
            district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = district.page;
            page.removeElement(district);
            setTimeout(() => {
              const _province = this.survey.getQuestionByName("province");
              const _page = _province.page;
              const originalIndex = _page.elements.indexOf(_province);
              this.survey.setValue("district", null);
              _page.addElement(district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "district") {
          const sub_district = this.survey.getQuestionByName("sub_district");
          if (sub_district) {
            let list = [];
            let readOnly = true;
            if (value) {
              readOnly = false;
              list = sub_districts
                .filter((x) => x.district_id == value)
                .map((x) => {
                  return {
                    value: x.id,
                    text: x.name_th,
                  };
                });
            }
            sub_district.readOnly = readOnly;
            sub_district.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = sub_district.page;
            page.removeElement(sub_district);
            setTimeout(() => {
              const _district = this.survey.getQuestionByName("district");
              const _page = _district.page;
              const originalIndex = _page.elements.indexOf(_district);
              this.survey.setValue("sub_district", null);
              _page.addElement(sub_district, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        if (name == "sub_district") {
          const zip_code = this.survey.getQuestionByName("zip_code");
          if (zip_code) {
            let list = [];
            let readOnly = true;
            let _value = null;
            if (value) {
              readOnly = false;
              const model = sub_districts.find((x) => x.id == value);
              const zip_codes = model?.zip_codes || [];
              if (zip_codes.length > 0) {
                _value = `${model.id}_${zip_codes[0]}`;
              }
              for (let item of zip_codes) {
                list.push({
                  value: `${model.id}_${item}`,
                  text: `${item}`,
                });
              }
            }
            zip_code.readOnly = readOnly;
            zip_code.choices = list;
            // ========== ========== ========== ==========
            _isAppLoading(true);
            const page = zip_code.page;
            page.removeElement(zip_code);
            setTimeout(() => {
              const _sub_district =
                this.survey.getQuestionByName("sub_district");
              const _page = _sub_district.page;
              const originalIndex = _page.elements.indexOf(_sub_district);
              this.survey.setValue("zip_code", _value);
              _page.addElement(zip_code, originalIndex + 1);
              _isAppLoading(false);
            }, 100);
          }
        }
        // ========== ========== Brand Branch ========== ==========
        const branch_brand_first_questions =
          questions.find((x) => ["branch", "brand"].includes(x.name))?.name ||
          "";
        if (name == branch_brand_first_questions) {
          const second_question =
            branch_brand_first_questions == "branch" ? "brand" : "branch";
          const second = this.survey.getQuestionByName(second_question);
          if (second) {
            let is_same_page = true;
            const first = this.survey.getQuestionByName(
              branch_brand_first_questions
            );
            if (first.page.name != second.page.name) {
              is_same_page = false;
            }
            let list = [];
            let visible = false;
            if (value) {
              visible = true;
              const brands_branches = this.missionDetail?.brands_branches || [];
              const choice = brands_branches
                .filter(
                  (x) =>
                    x[`${branch_brand_first_questions}_name`] == value &&
                    x[`${second_question}_name`]
                )
                .map((x) => x[`${second_question}_name`]);
              const grouped = Object.groupBy(choice, (item) => item);
              console.log(grouped);
              list = Object.keys(grouped);
            }
            second.visible = visible;
            if (list.length == 0) {
              second.visible = false;
            }
            second.choices = list;
            // ========== ========== ========== ==========
            if (is_same_page) {
              _isAppLoading(true);
              const page = second.page;
              page.removeElement(second);
              setTimeout(() => {
                const _first = this.survey.getQuestionByName(
                  branch_brand_first_questions
                );
                const _page = _first.page;
                const originalIndex = _page.elements.indexOf(_first);
                this.survey.setValue(second_question, null);
                _page.addElement(second, originalIndex + 1);
                _isAppLoading(false);
              }, 100);
            }
          }
        }
        // ========== ========== ========== ==========
      });
    },
    setQuestionAddress(schema) {
      let pages = schema?.pages || [];
      const setAddress = (elements) => {
        if (Array.isArray(elements)) {
          const province = elements.find((x) => x.name == "province");
          if (province) {
            province.choices = provinces.map((x) => {
              return {
                value: x.id,
                text: x.name_th,
              };
            });
          }
          // ========== ========== ========== ==========
          const district = elements.find((x) => x.name == "district");
          if (district) {
            district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const sub_district = elements.find((x) => x.name == "sub_district");
          if (sub_district) {
            sub_district.readOnly = true;
          }
          // ========== ========== ========== ==========
          const zip_code = elements.find((x) => x.name == "zip_code");
          if (zip_code) {
            zip_code.readOnly = true;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let elements = item?.elements || [];
          elements = setAddress(elements);
          if (item) {
            item.elements = elements;
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        elements = setAddress(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    setQuestionBrandBranch(schema) {
      let pages = schema?.pages || [];
      const brands_branches = this.missionDetail?.brands_branches || [];
      let first_question = "";
      let second_question = "";
      let flat_question = [];
      let is_same_page = true;
      const setBrandBranch = (elements) => {
        second_question = first_question == "branch" ? "brand" : "branch";
        if (Array.isArray(elements)) {
          const first = elements.find((x) => x.name == first_question);
          if (first) {
            const first_choice = brands_branches
              .filter((x) => x[`${first_question}_name`])
              .map((x) => x[`${first_question}_name`]);
            const grouped = Object.groupBy(first_choice, (item) => item);
            first.choices = Object.keys(grouped);
          }
          // ========== ========== ========== ==========
          const second = elements.find((x) => x.name == second_question);
          if (second && is_same_page) {
            second.visible = false;
          }
        }
        return elements;
      };
      if (Array.isArray(pages) && pages.length > 0) {
        for (let item of pages) {
          let element = item.elements.map((x) => {
            return {
              ...x,
              page: item.name,
            };
          });
          if (Array.isArray(element)) {
            flat_question = [...flat_question, ...element];
          }
        }
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        const branch = flat_question.find((x) => ["branch"].includes(x.name));
        const brand = flat_question.find((x) => ["brand"].includes(x.name));
        if (branch && brand) {
          if (branch.page != brand.page) {
            is_same_page = false;
          }
        }
        if (first_question) {
          for (let item of pages) {
            let elements = item?.elements || [];
            elements = setBrandBranch(elements);
            if (item) {
              item.elements = elements;
            }
          }
        }
        if (schema) {
          schema.pages = pages;
        }
      } else {
        let elements = schema?.elements || [];
        flat_question = [...elements];
        first_question =
          flat_question.find((x) => ["branch", "brand"].includes(x.name))
            ?.name || "";
        elements = setBrandBranch(elements);
        if (schema) {
          schema.elements = elements;
        }
      }
      return schema;
    },
    async getMyMissionById(id) {
      try {
        const myMission = await Axios.get("mission/getMyMission", {
          params: {
            employee_mission_id: id,
            view_in_period_remind_date: false,
            view_limit_reached: false,
          },
        });
        if (myMission.data?.status == "success") {
          this.missionDetail = myMission.data.data;
          // this.missionDetail.use_timer = true;
          // this.missionDetail.time_sec = this.missionDetail?.time_sec || 20;
          // this.timeSec = this.missionDetail?.time_sec;
          this.detail.employee_note = this.missionDetail?.employee_note || "";
          if (this.missionDetail?.use_timer) {
            this.missionDetail.time_sec = this.missionDetail?.time_sec || 0;
            this.timeSec = this.missionDetail?.time_sec;
          }

          if (
            this.missionDetail.not_allowed &&
            this.missionDetail.employee_mission_id != null
          ) {
            this.$router.push({
              name: "my-mission-detail",
              params: { id: this.missionDetail.employee_mission_id },
            });
          } else if (this.missionDetail.not_allowed) {
            this.$swal
              .fire({
                icon: "error",
                title: this.$t("messageActivityErrorReJoin"),
                showConfirmButton: false,
                timer: 4000,
              })
              .then(() => {
                this.isAppLoading(false);
                this.$router.push({
                  name: "mission",
                });
              });
          }
        }
      } catch (err) {
        console.log("getMissionById", err);
        this.$swal
          .fire({
            icon: "error",
            title: err?.response?.data?.message,
            showConfirmButton: false,
            timer: 4000,
          })
          .then(() => {
            this.isAppLoading(false);
            this.$router.push({
              name: "mission",
            });
          });
      }
    },
    async surveyComplete(sender, options) {
      this.onStopInterval();
      options.showSaveInProgress();
      const result = await this.mapQuestionAnswer();
      // check if mission has reward
      if (
        this.missionDetail.use_reward == true &&
        Array.isArray(this.missionDetail.mission_rewards) &&
        this.missionDetail.mission_rewards.length > 0
      ) {
        this.sendFormSurveyMissionReward(result);
      } else {
        this.sendFormSurvey(result);
      }

      options.showSaveSuccess();
    },
    onSetInterval() {
      if (this.missionDetail?.use_timer) {
        if (this.timeSec > 0 && this.missionDetail?.time_sec > 0) {
          const countDefault = this.missionDetail?.time_sec * 10;
          let count = 1;
          this.timerValueInterval = setInterval(() => {
            if (countDefault > 0 && count <= countDefault) {
              if (this.timeSec > 0) {
                const diff = countDefault - count;
                const percent = (diff * 100) / countDefault;
                this.timeValue = Math.round(percent);
              } else {
                this.timeValue = 100;
              }
              count++;
            }
          }, 100);

          this.timerInterval = setInterval(() => {
            this.timeSec--;
          }, 1000);
        }
      }
    },
    onStopInterval() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
      }
      if (this.timerValueInterval) {
        clearInterval(this.timerValueInterval);
      }
    },
    uploadImage() {
      this.survey.onUploadFiles.add(function (_, options) {
        options.files.forEach(function (file) {
          const formData = new FormData();
          formData.append("image", file);
          Axios.post("/mission/uploadImageSurvey", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
            .then(({ data }) => {
              if (data.status == "success") {
                options.callback("success", [
                  {
                    file: file,
                    content: data.image_url,
                  },
                ]);
              }
            })
            .catch((err) => {
              throw err;
            });
        });
      });
    },
    calculateTotalScoreExam(data) {
      var totalScore = 0;
      Object.keys(data).forEach((qName) => {
        const question = this.survey.getQuestionByValueName(qName);
        if (question.isAnswerCorrect()) {
          totalScore += 1;
        }
      });
      return totalScore;
    },
    calculateMaxQuestion(questions) {
      var totalScore = 0;
      questions.forEach((question) => {
        if (question.correctAnswer) {
          totalScore += 1;
        }
      });
      return totalScore;
    },
    calculateMaxScore(questions) {
      var maxScore = 0;
      questions.forEach((question) => {
        if (question.choices) {
          const maxValue = Math.max.apply(
            Math,
            question.choices.map((o) => {
              return parseInt(o.score);
            })
          );
          maxScore += parseInt(maxValue);
        }
        if (question.rateValues) {
          const maxValue = Math.max.apply(
            Math,
            question.rateValues.map((o) => o.score)
          );
          maxScore += maxValue;
        }
        if (question.getType() === "matrix") {
          const maxMatrixValue =
            Math.max.apply(
              Math,
              question.columns.map((o) => o.score)
            ) * question.rows.length;
          maxScore += maxMatrixValue;
        }
      });
      return maxScore;
    },
    calculateTotalScore(data) {
      var totalScore = 0;
      data.forEach((item) => {
        const question = this.survey.getQuestionByValueName(item.name);
        const qValue = item.value;
        if (question.choices) {
          const selectedChoice = question.choices.find(
            (choice) => choice.value === qValue
          );

          if (selectedChoice) {
            selectedChoice.score =
              selectedChoice.score == undefined ? 1 : selectedChoice.score;
            totalScore += selectedChoice.score;
          }
        }
        if (question.rateValues) {
          const selectedRate = question.rateValues.find(
            (rate) => rate.value === qValue
          );
          if (selectedRate) {
            totalScore += selectedRate.score;
          }
        }
        if (question.getType() === "matrix") {
          item.data.forEach((dataItem) => {
            if (dataItem.value) {
              totalScore += dataItem.score;
            }
          });
        }
      });
      return totalScore;
    },
    // ========== ========== Check Upload ========== ==========
    checkUpload() {
      this.survey.onValidateQuestion.add((sender, options) => {
        const value = options.value;
        const question = options.question;
        const type = question?.getType();
        if (type == "file") {
          const maxUpload = question?.maxUpload || question?.jsonObj?.maxUpload;
          if (value?.length > maxUpload) {
            options.error = this.$t("maxFilesAllowed", { count: maxUpload });
          } else if (value?.length > 0) {
            let checkAcceptedType = false;
            const obj = question?.jsonObj;
            const acceptedTypes = obj?.acceptedTypes;
            const file_name = value[0].name;
            if (acceptedTypes) {
              const acceptedTypeSplit = acceptedTypes.split(",");
              for (let item of acceptedTypeSplit) {
                if (item.includes("image/")) {
                  checkAcceptedType = this.isImage(file_name);
                } else if (item.includes("video/")) {
                  checkAcceptedType = this.isVideo(file_name);
                } else if (item.includes("application/pdf")) {
                  checkAcceptedType = this.isPDF(file_name);
                } else if (
                  item.includes("text/csv") ||
                  item.includes(
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  ) ||
                  item.includes("application/vnd.ms-excel")
                ) {
                  checkAcceptedType = this.isSpreadsheet(file_name);
                } else if (item == "*") {
                  checkAcceptedType = true;
                }
                if (checkAcceptedType) {
                  break;
                }
              }
            } else {
              checkAcceptedType = true;
            }
            if (!checkAcceptedType) {
              options.error = this.$t("invalidFileFormat");
            }
          }
        }
      });
    },
    isImage(link) {
      return /\.(gif|jpe?g|jfif|tiff?|png|webp|bmp|avif|svg)$/i.test(link);
    },
    isVideo(link) {
      return /\.(mp4|webm|ogg|avi|mov)$/i.test(link);
    },
    isPDF(link) {
      return /\.pdf$/i.test(link);
    },
    isSpreadsheet(link) {
      return /\.(xls|xlsx|csv)$/i.test(link);
    },
    // ========== ========== ========== ==========
    async mapQuestionAnswer() {
      const objectResult = {};
      const promises = [];

      for (const key in this.survey.data) {
        objectResult[key] = this.survey.data[key];
      }

      return Promise.all(promises).then(() => objectResult);
    },
    reRender() {
      setTimeout(() => {
        this.$forceUpdate();
      }, 1000);
    },
    async uploadImageSurvey(file) {
      return new Promise((resolve) => {
        let formData = new FormData();
        formData.append("image", file);
        Axios.post("mission/uploadImageSurvey", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
          .then(({ data }) => {
            if (data.status == "success") {
              resolve(data.image_url);
            }
          })
          .catch((err) => {
            throw err;
          });
      });
    },
    async sendFormSurveyMissionReward(answers) {
      this.answer = answers;
      this.dialogRewardMission = true;
    },
    async sendFormSurvey(answers) {
      this.answer = answers;
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(this.survey.jsonObj, answers);
      // ========== ========== ========== ==========
      if (this.missionDetail.type == "exam") {
        const { expected_type, expected_num } =
          this.missionDetail.schema_survey;

        if (expected_type == "percent") {
          this.status =
            (Number(answers.totalScore) / Number(answers.maxScore)) * 100 >=
            Number(expected_num)
              ? "success"
              : "fail";
        } else {
          this.status =
            Number(answers.totalScore) >= Number(expected_num)
              ? "success"
              : "fail";
        }

        this.isAppLoading(true);
        Axios.post("mission/confirmMissionExam", {
          answer: JSON.stringify(formatJson),
          employee_mission_id: this.$route.params.id,
          point: answers.totalScore,
          status: this.status,
        })
          .then(({ data }) => {
            this.$swal
              .fire({
                icon: "success",
                title: data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                this.isAppLoading(false);
                this.$router.push({
                  name: "mission",
                });
              });
          })
          .catch(() => {
            this.isAppLoading(false);
            this.$router.push({
              name: "mission",
            });
          });
      } else {
        // ========== ========== ========== ==========
        if (this.missionDetail.type === "survey") {
          if (Array.isArray(this.missionDetail?.schema_survey?.pages)) {
            let listComponentRanking = [];
            for (let item of this.missionDetail?.schema_survey?.pages) {
              let _list = item.elements?.filter((x) => x.type === "ranking");
              listComponentRanking = [...listComponentRanking, ..._list];
            }
            for (let item of listComponentRanking) {
              let model = answers[`${item.name}`];
              if (!model) {
                answers[`${item.name}`] = item.choices || [];
              }
            }
          }
        }
        // ========== ========== ========== ==========
        if (this.missionDetail.type === "survey-summary") {
          this.conditionResult();
          this.dialogConditionResult = true;
          return;
        }
        // ========== ========== ========== ==========
        await this.confirmMissionSurvey({
          answer: JSON.stringify(formatJson),
          employee_mission_id: this.$route.params.id,
          status: this.status,
        });
      }
    },
    async sendFormSurveyDefault(answers) {
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(this.survey.jsonObj, answers);
      // ========== ========== ========== ==========
      await this.confirmMissionSurvey({
        answer: JSON.stringify(formatJson),
        employee_mission_id: this.$route.params.id,
        status: this.status,
      });
    },
    async confirmMissionSurvey(body) {
      this.isAppLoading(true);
      Axios.post("mission/confirmMissionSurvey", body)
        .then(({ data }) => {
          if (data.status == "success") {
            this.$swal
              .fire({
                icon: "success",
                title: data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                this.$router.push({
                  name: "mission",
                });
              });
          } else if (data.status == "error_try_again") {
            this.$swal
              .fire({
                icon: "error",
                title: data.message,
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                if (
                  this.missionDetail.use_reward &&
                  Array.isArray(this.missionDetail.mission_rewards) &&
                  this.missionDetail.mission_rewards.length > 0
                ) {
                  this.dialogRewardMission = true;
                } else {
                  this.$router.push({
                    name: "mission",
                  });
                }
              });
          }
        })
        .catch((err) => {
          this.$swal
            .fire({
              icon: "error",
              title: err.response?.data?.message,
              showConfirmButton: false,
              timer: 3000,
            })
            .then(() => {
              this.$router.push({
                name: "mission",
              });
            });
        })
        .finally(() => {
          this.isAppLoading(false);
        });
    },
    confirmConditionResult() {
      this.dialogConditionResult = false;
      this.sendFormSurveyDefault(this.answer);
    },
    conditionResult() {
      if (
        this.missionDetail.schema_survey &&
        Array.isArray(this.missionDetail.schema_survey.pages)
      ) {
        const pages = this.missionDetail.schema_survey.pages;
        const condition_result = this.missionDetail.condition_result;
        let _choices = [];
        let _questions = [];
        let _answers = [];
        for (let item of pages) {
          item.elements.map((_element) => {
            _questions.push(_element);
            if (this.answer[_element.name]) {
              const ans = this.answer[_element.name];
              const index = _element.choices.findIndex(
                (x) => x == ans || x.value == ans
              );
              if (index >= 0) {
                _choices.push(index + 1);
                _answers.push({
                  question: _element.name,
                  answer: ans,
                });
              }
            }
          });
        }
        if (condition_result?.type == "most-selected") {
          const mostFrequentValue = this.getMostFrequentValue(_choices);
          if (Array.isArray(condition_result.list)) {
            const model = condition_result.list.find(
              (x) => x.choice == mostFrequentValue
            );
            this.conditionResultDetail = model ? { ...model } : null;
          }
        } else if (condition_result?.type == "weighted-scoring") {
          const sumChoiceValue = this.getSumChoiceValue(_questions, _answers);
          if (Array.isArray(condition_result.list)) {
            const model = condition_result.list.find((x) => {
              let check = false;
              let min = 0;
              let max = 0;
              if (!isNaN(Number(x.min))) {
                min = x.min;
              }
              if (!isNaN(Number(x.max))) {
                max = x.max;
              }
              if (min <= sumChoiceValue && sumChoiceValue <= max) {
                check = true;
              }
              return check;
            });
            this.conditionResultDetail = model ? { ...model } : null;
          }
        }
      }
    },
    getMostFrequentValue(arr) {
      if (arr.length === 0) return null;

      const frequencyMap = {};

      // Create frequency map
      arr.forEach((item) => {
        if (frequencyMap[item]) {
          frequencyMap[item]++;
        } else {
          frequencyMap[item] = 1;
        }
      });

      // Find the element with the highest frequency
      let maxCount = 0;
      let mostFrequentElement = arr[0];

      for (const [key, value] of Object.entries(frequencyMap)) {
        if (value > maxCount) {
          maxCount = value;
          mostFrequentElement = key;
        }
      }

      return mostFrequentElement;
    },
    getSumChoiceValue(questions, answers) {
      let sumChoiceValue = 0;
      for (let item of questions) {
        let model = answers.find((x) => x.question == item.name);
        if (model) {
          let choice = item.choices.find(
            (x) => x.value == model.answer || x == model.answer
          );
          if (choice) {
            sumChoiceValue += choice.score == undefined ? 1 : choice.score;
          }
        }
      }
      return sumChoiceValue;
    },
    async confirmMissionReward({ rewardSelect }) {
      const isUseIdCard = rewardSelect.some(
        (item) => item.is_use_id_card === true
      );
      this.isLoading = true;

      //-----------------------------------------
      let addressId = null;
      if (this.detail.chooseAddress === "transport") {
        if (!this.userAddress) {
          this.isLoading = false;
          return;
        }
        addressId = this.userAddress.id;
      }
      //---------------------------------

      if (
        isUseIdCard &&
        !this.detail.id_card_image &&
        !this.detail.id_card_image_watermark
      ) {
        this.detail.image_error = true;
        this.isLoading = false;
        return;
      }
      //----------------------------------------------------------------
      if (!this.detail.id_card_image_watermark) {
        const element = document.getElementById("id_card_image");
        if (element) {
          let dataUrl = null;
          dataUrl = await this.byhtmlToImage(element);
          const id_card_image_watermark = await this.convertDetailImageBase64(
            dataUrl
          );
          if (id_card_image_watermark) {
            this.detail.id_card_image_watermark = id_card_image_watermark;
          }
        }
      }
      //----------------------------------------------------------------
      if (isUseIdCard && !this.detail.id_card_image_watermark) {
        this.isLoading = false;
        return;
      }
      //----------------------------------------------------------------

      let answers = this.answer;
      if (Array.isArray(this.missionDetail?.schema_survey?.pages)) {
        let listComponentRanking = [];
        for (let item of this.missionDetail?.schema_survey?.pages) {
          let _list = item.elements?.filter((x) => x.type === "ranking");
          listComponentRanking = [...listComponentRanking, ..._list];
        }
        for (let item of listComponentRanking) {
          let model = answers[`${item.name}`];
          if (!model) {
            answers[`${item.name}`] = item.choices || [];
          }
        }
      }
      // ========== ========== ========== ==========
      const formatJson = formattedForSave(this.survey.jsonObj, answers);
      // ========== ========== ========== ==========
      await this.confirmMissionSurvey({
        answer: JSON.stringify(formatJson),
        employee_mission_id: this.$route.params.id,
        mission_rewards: rewardSelect,
        address_id: addressId,
        status: this.status,
        id_card_image: this.detail.id_card_image_watermark,
        employee_note: this.detail.employee_note,
      });
      this.isLoading = false;
    },
  },
  computed: {
    ...mapState("defaultSystem", ["site"]),
  },
  watch: {
    timeSec: {
      handler() {
        if (this.missionDetail?.use_timer && this.timeSec <= 0) {
          this.onStopInterval();
          setTimeout(() => {
            this.$swal
              .fire({
                icon: "error",
                title: this.$t("errTimeOut"),
                showConfirmButton: false,
                timer: 3000,
              })
              .then(() => {
                this.$router.push({
                  name: "mission",
                });
              });
          }, 500);
        }
      },
      deep: true,
      immediate: true,
    },
  },
  filters: {
    formatTimer: function (value) {
      if (!value) return "0:00";
      const formatted = moment.utc(value * 1000).format("m:ss");
      return formatted;
    },
  },
};
</script>

<style>
.sv-ranking--mobile .sv-ranking-item__icon-container {
  display: none;
}

.sv-ranking--mobile .sv-ranking-item__content {
  padding-left: 0;
  width: 100%;
}

.sv-ranking--mobile .sv-ranking-item__index {
  padding: 5px 11px;
  vertical-align: top;
}

.sv-ranking--mobile .sv-ranking-item__text {
  max-width: calc(100% - 50px);
  margin-top: 5px;
}

.sd-element__title span {
  color: black;
}

.sd-item__control-label {
  color: black;
}

.sv-components-column .sd-action-bar #sv-nav-complete {
  display: block !important;
}

.borderActive {
  border: 1px solid #5a5a5a;
  border-radius: 5px;
}

.timer-container {
  position: fixed;
  top: 12px;
  right: 12px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: #ffffff;
  z-index: 1;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.1);
  border: 0.1px solid rgba(0, 0, 0, 0.1);
}

.timer-sub-container {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.circular-progress {
  width: 100%;
  height: 100%;
  --size: 250px;
  --half-size: calc(var(--size) / 2);
  --stroke-width: 12px;
  --radius: calc((var(--size) - var(--stroke-width)) / 2);
  --circumference: calc(var(--radius) * 3.1416 * 2);
  --dash: calc((var(--progress) * var(--circumference)) / 100);
}

.circular-progress circle {
  cx: var(--half-size);
  cy: var(--half-size);
  r: var(--radius);
  stroke-width: var(--stroke-width);
  fill: none;
  stroke-linecap: round;
}

.circular-progress circle.bg {
  stroke: #ddd;
}

.circular-progress circle.fg {
  transform: rotate(-90deg);
  transform-origin: var(--half-size) var(--half-size);
  stroke-dasharray: var(--dash) calc(var(--circumference) - var(--dash));
  transition: stroke-dasharray 0.3s linear 0s;
  stroke: #5394fd;
}
</style>

<style scoped>
::v-deep .sd-html span {
  font-size: inherit;
  /* ใช้ขนาดตาม h1 */
  font-weight: inherit;
  /* ใช้น้ำหนักตัวอักษรตาม h1 */
}

::v-deep .sd-html h1 {
  line-height: 1.5 !important;
}

::v-deep .sd-html h2 {
  line-height: 1.5 !important;
}

::v-deep .sd-html h3 {
  line-height: 1.5 !important;
}

::v-deep .sd-html h4 {
  line-height: 1.5 !important;
}

.description-label {
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>